<panel *ngIf="!selected.invoice && (!loading || !invoices.empty)">
  <div header class="uppercase">{{'Đơn nhập chưa về hàng' | lang}}</div>
  <div class="flex" right>
    <text-filter class="flex-grow-1" [target]="invoices" [placeholder]="'Tìm kiếm đơn hàng'"></text-filter>
    <button class="bg-primary text-white pointer hlf-margin-left" (click)="create()"><i class="fa fa-plus"></i></button>
  </div>

  <table responsive class="data hover" *ngIf="!selected.invoice">
    <tr>
      <th class="text-right">{{'STT' | lang}}</th>
      <th class="text-left nowrap"><sortable [target]="invoices" [extractor]="extractor('Stamp')" [selected]="true">{{'Ngày' | lang}}</sortable></th>
      <th class="text-center"><sortable [target]="invoices" [extractor]="extractor('ID')">{{'Mã đơn' | lang}}</sortable></th>
      <th class="text-center"><sortable [target]="invoices" [extractor]="extractor('State')">{{'Trạng thái' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="invoices" [extractor]="extractor('Products')">{{'Mặt hàng' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="invoices" [extractor]="extractor('Count')">{{'Số cây' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="invoices" [extractor]="extractor('LengthActualQuantity')">{{'Số mét' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="invoices" [extractor]="extractor('WeightActualQuantity')">{{'Số cân' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="invoices" [extractor]="extractor('Total')">{{'Tổng tiền' | lang}}</sortable></th>
    </tr>
    <tr *ngFor="let i of invoices.pageMatches; index as ix" class="pointer" (click)="open(i)">
      <td><small>{{ix + 1 + invoices.pageIndex * invoices.pageSize}}</small></td>
      <td>{{i.Stamp | date : 'dd-MM-yyyy'}}</td>
      <td class="spacy bold text-danger">{{i.Tag}}</td>
      <td class="uppercase small nowrap" [ngClass]="{'text-warning': i.State == 1, 'text-success': i.State == 2}">{{state(i) | lang}}</td>
      <td>{{i.SKUCount | number : '1.0-0' : 'en-US'}}</td>
      <td>
        {{i.LengthCount + i.WeightCount | number : '1.0-0' : 'en-US'}}<unit>{{'cây' | lang}}</unit>
      </td>
      <td>{{i.LengthActualQuantity | number : '1.1-1' : 'en-US'}}<m></m></td>
      <td>{{i.WeightActualQuantity | number : '1.1-1' : 'en-US'}}<kg></kg></td>
      <td><b class="text-danger">{{i.Total | number : '1.1-1' : 'en-US'}}</b><unit>{{i.Icon}}</unit></td>
    </tr>
    <tr class="footer" *ngIf="invoices.pages.length > 1">
      <td [colSpan]="9" class="text-center" style="display: table-cell !important"><pagination [target]="invoices"></pagination></td>
    </tr>
  </table>

</panel>

<div class="editor" *ngIf="selected.invoice">

  <div class="scrollable-x" #scrollableX>

    <div class="flex row">

      <panel [header]="false">

        <div class="flex col">

          <div class="flex space-between items-center header">
            <div class="bold uppercase">{{selected.invoice.ID < 1 ? ('Lên đơn nhập hàng mới' | lang) : ('Chỉnh sửa đơn nhập hàng' | lang)}} <span class="text-danger pointer" *ngIf="selected.invoice.ID > 0" (click)="editTag()">{{selected.invoice.Tag}}</span> (<span class="text-primary pointer" (click)="editStamp()">{{selected.invoice.Stamp | date : 'dd-MM-yyyy'}}</span>)</div>
            <small *ngIf="selected.invoice.ID > 0" class="button uppercase" (click)="close()">{{'Đóng đơn' | lang}}</small>
          </div>

          <div class="flex row">

            <div class="scrollable" #scrollableLeft>


              <table responsive class="data" *ngIf="selected.invoice">
                <tr>
                  <th class="text-top text-left">{{'Mã đặt hàng' | lang}}</th>
                  <th class="text-top text-left">{{'Khách hàng' | lang}}</th>
                  <th class="text-top text-center" *ngIf="hasGenericOrder">{{'Số lượng' | lang}}</th>
                  <th class="text-top text-center">{{'Mã hàng' | lang}}</th>
                  <th class="text-top text-center">{{'Màu' | lang}}</th>
                  <th class="text-top text-center">{{'Số cây' | lang}}</th>
                  <th class="text-top text-left">{{'Dài / nặng từng cây' | lang}}</th>
                  <th class="text-bottom text-right">{{'Tổng dài' | lang}}</th>
                  <th class="text-bottom text-center">{{'Khấu trừ' | lang}}</th>
                  <th class="text-bottom text-right">{{'Tính tiền' | lang}}</th>
                  <th class="text-bottom text-right">{{'Giá nhập' | lang}}</th>
                  <th class="text-bottom text-right">{{'Thành tiền' | lang}}</th>
                </tr>

                <ng-container *ngFor="let order of this.selected.groups; index as ox">

                  <tr *ngFor="let i of order; index as ix" [ngClass]="{'dark': ox % 2 == 0 && this.selected.groups.length > 1}">
                    <td class="spacy nowrap bold text-primary">{{ix < 1 ? i.OrderTag : ''}}</td>
                    <td>
                      <ng-container *ngIf="ix < 1 || i.Partners.length > 1">
                        <ng-container *ngFor="let partner of i.Partners">
                          <div *ngIf="partner.Quantity > 0" class="nowrap uppercase" style="line-height: 21px">{{partner.Name}}</div>
                        </ng-container>
                      </ng-container>
                      <div *ngIf="warehouseCount(i) > 0" class="nowrap uppercase bold text-primary">{{'Nhập kho' | lang}}</div>
                    </td>
                    <td *ngIf="hasGenericOrder">
                      <ng-container *ngIf="ix < 1 || i.Partners.length > 1">
                        <ng-container *ngFor="let partner of i.Partners">
                          <div *ngIf="partner.Quantity > 0"><number-input class="text-info bold" [fit]="true" [allowNegative]="false" [value]="partner.Provided" (change)="setGenericCount(partner, $event.target)"></number-input><span class="small opacity-75 hlf-margin-left">/{{partner.Quantity}}</span></div>
                        </ng-container>
                      </ng-container>
                      <div *ngIf="warehouseCount(i) > 0" class="nowrap uppercase bold text-primary">{{warehouseCount(i)}}</div>
                    </td>
                    <td><good class="bold spacy nowrap" [sku]="i.SKU"></good></td>
                    <td class="bold">{{i.Color}}</td>
                    <td>
                      <number-input class="text-info bold" [allowNegative]="false" [value]="i.records.length" (change)="setCount(i, $event.target)"></number-input>
                    </td>
                    <td>
                      <div class="flex inputs">
                        <span *ngFor="let o of i.records">
                          <number-input *ngIf="editable" class="text-center" [ngClass]="{'text-danger': o.ActualQuantity == 0, 'text-success': o.ActualQuantity > 0}" [allowNegative]="false" [decimalPlaces]="1" [value]="o.ActualQuantity" (change)="setLength(o, $event.target)"><i class="small fa fa-times text-danger hlf-margin-left hlf-margin-right pointer" after (click)="remove([o])"></i></number-input>
                          <ng-container *ngIf="!editable">{{o.ActualQuantity | number : '1.1-1' : 'en-US'}}</ng-container>
                        </span>
                      </div>
                    </td>
                    <td class="nowrap">
                      <b>{{statistics('ActualQuantity', [i]) | number : '1.1-1' : 'en-US'}}</b><product-unit [type]="i.Unit"></product-unit>
                    </td>
                    <td><number-input class="bold text-info" [fit]="true" [allowNegative]="false" [value]="i.Reduced" (change)="setReduce(i, $event.target)"></number-input><product-unit [type]="i.Unit"></product-unit></td>
                    <td class="nowrap">
                      <b>{{statistics('QuoteQuantity', [i]) | number : '1.1-1' : 'en-US'}}</b><product-unit [type]="i.Unit"></product-unit>
                    </td>
                    <td class="nowrap">
                      <b *ngIf="!i.IsPriceEditable">{{i.QuotePrice | number : '1.1-1' : 'en-US'}}</b>
                      <number-input *ngIf="i.IsPriceEditable" class="bold" [ngClass]="{'text-success': i.QuotePrice > 0, 'text-danger': i.QuotePrice == 0}" [fit]="true" [allowNegative]="false" [value]="i.QuotePrice" [decimalPlaces]="1" (change)="setPrice(i, $event.target)"></number-input>
                      <symbol-per-unit [symbol]="'CNY'" [type]="i.Unit"></symbol-per-unit>
                    </td>
                    <td class="nowrap">
                      <b>{{statistics('Total', [i]) | number : '1.1-1' : 'en-US'}}</b><cny></cny>
                    </td>
                  </tr>

                  <tr class="small text-info" [ngClass]="{'dark' : ox % 2 == 0}" *ngIf="order.length > 1 && selected.groups.length > 1">
                    <td class="nowrap bold uppercase">{{'Tổng thành phần' | lang}}</td>
                    <td></td>
                    <td *ngIf="hasGenericOrder"></td>
                    <td><b>{{statistics('SKU', order) | number : '1.0-0' : 'en-US'}}</b><unit>{{'mã' | lang}}</unit></td>
                    <td><b>{{statistics('Color', order) | number : '1.0-0' : 'en-US'}}</b><unit>{{'màu' | lang}}</unit></td>
                    <td><b>{{statistics('Count', order) | number : '1.0-0' : 'en-US'}}</b><unit>{{'cây' | lang}}</unit></td>
                    <td></td>
                    <td>
                      <b>{{statistics('ActualQuantity', order) | number : '1.1-1' : 'en-US'}}</b>
                      <m *ngIf="statistics('Count', order, 1) > 0 && statistics('Count', order, 2) < 1"></m>
                      <kg *ngIf="statistics('Count', order, 2) > 0 && statistics('Count', order, 1) < 1"></kg>
                      <unit *ngIf="statistics('Count', order, 1) > 0 && statistics('Count', order, 2) > 0">{{'đv' | lang}}</unit>
                    </td>
                    <td>
                      <b>{{statistics('ReducedQuantity', order) | number : '1.1-1' : 'en-US'}}</b>
                      <m *ngIf="statistics('Count', order, 1) > 0 && statistics('Count', order, 2) < 1"></m>
                      <kg *ngIf="statistics('Count', order, 2) > 0 && statistics('Count', order, 1) < 1"></kg>
                      <unit *ngIf="statistics('Count', order, 1) > 0 && statistics('Count', order, 2) > 0">{{'đv' | lang}}</unit>
                    </td>
                    <td>
                      <b>{{statistics('QuoteQuantity', order) | number : '1.1-1' : 'en-US'}}</b>
                      <m *ngIf="statistics('Count', order, 1) > 0 && statistics('Count', order, 2) < 1"></m>
                      <kg *ngIf="statistics('Count', order, 2) > 0 && statistics('Count', order, 1) < 1"></kg>
                      <unit *ngIf="statistics('Count', order, 1) > 0 && statistics('Count', order, 2) > 0">{{'đv' | lang}}</unit>
                    </td>
                    <td></td>
                    <td><b>{{statistics('Total', order) | number : '1.1-1' : 'en-US'}}</b><cny></cny></td>
                  </tr>

                </ng-container>

                <tr class="footer text-primary" *ngIf="!empty">
                  <td class="bold uppercase">{{'Tổng đơn' | lang}}</td>
                  <td></td>
                  <td *ngIf="hasGenericOrder"></td>
                  <td class="nowrap"><b>{{sum('SKU', order) | number : '1.0-0' : 'en-US'}}</b><unit>{{'mã' | lang}}</unit></td>
                  <td class="nowrap"><b>{{sum('Color', order) | number : '1.0-0' : 'en-US'}}</b><unit>{{'màu' | lang}}</unit></td>
                  <td class="nowrap"><b>{{sum('Count', order) | number : '1.0-0' : 'en-US'}}</b><unit>{{'cây' | lang}}</unit></td>
                  <td></td>
                  <td class="nowrap">
                    <b>{{sum('ActualQuantity') | number : '1.1-1' : 'en-US'}}</b>
                    <m *ngIf="sum('Count', 1) > 0 && sum('Count', 2) < 1"></m>
                    <kg *ngIf="sum('Count', 2) > 0 && sum('Count', 1) < 1"></kg>
                    <unit *ngIf="sum('Count', 1) > 0 && sum('Count', 2) > 0">{{'đv' | lang}}</unit>
                  </td>
                  <td class="nowrap">
                    <b>{{sum('ReducedQuantity') | number : '1.1-1' : 'en-US'}}</b>
                    <m *ngIf="sum('Count', 1) > 0 && sum('Count', 2) < 1"></m>
                    <kg *ngIf="sum('Count', 2) > 0 && sum('Count', 1) < 1"></kg>
                    <unit *ngIf="sum('Count', 1) > 0 && sum('Count', 2) > 0">{{'đv' | lang}}</unit>
                  </td>
                  <td class="nowrap">
                    <b>{{sum('QuoteQuantity') | number : '1.1-1' : 'en-US'}}</b>
                    <m *ngIf="sum('Count', 1) > 0 && sum('Count', 2) < 1"></m>
                    <kg *ngIf="sum('Count', 2) > 0 && sum('Count', 1) < 1"></kg>
                    <unit *ngIf="sum('Count', 1) > 0 && sum('Count', 2) > 0">{{'đv' | lang}}</unit>
                  </td>
                  <td></td>
                  <td class="nowrap">
                    <b>{{sum('Total') | number : '1.1-1' : 'en-US'}}</b><cny></cny>
                  </td>
                </tr>
              </table>

            </div>
            <scrollbar [target]="scrollableLeft"></scrollbar>

          </div>

          <div class="flex">
            <button *ngIf="!selected.invoice" class="bg-primary text-white" (click)="create()"><span>{{'Tạo đơn nhập hàng mới' | lang}}</span></button>
            <button *ngIf="savable" class="bg-primary text-white" (click)="save()"><span>{{selected.invoice.ID > 0 ? 'Cập nhập đơn hàng' : 'Tạo đơn hàng'}}</span></button>
            <button *ngIf="cancelable" class="bg-danger text-white" (click)="cancel()"><span>{{'Hủy đơn nhập hàng' | lang}}</span></button>
          </div>
        </div>
      </panel>

      <panel [header]="false" *ngIf="selected.invoice">

        <div class="flex col">

          <div class="header">
            <text-filter class="flex-grow-1" [placeholder]="'Tìm đơn hàng'" [target]="orders" *ngIf="!selected.order"></text-filter>
            <text-filter class="flex-grow-1" [placeholder]="'Tìm mã hàng'" [target]="details" *ngIf="selected.order"></text-filter>
            <button class="bg-warning text-white pointer hlf-margin-left flex-shrink-0" (click)="importData()"><i class="fa fa-file-excel"></i></button>
          </div>
                    
          <div class="flex row std-border-top">
            <div class="scrollable" #scrollableRight [ngClass]="{'full-height': !selected.order}">

              <ng-container *ngIf="!selected.order">

                <div *ngFor="let i of orders.matches" (click)="toggle(i)" [ngClass]="{'active': i == selected.order}">
                  <icon-text [icon]="'fa fa-file-download'">
                    <b>{{i.Tag}}</b>
                    <br />
                    <small class="uppercase bold">{{partner(i).Name}}</small>

                  </icon-text>
                </div>
              </ng-container>


              <table class="data hover" *ngIf="selected.order">
                <tr>
                  <th class="text-left">Mã hàng</th>
                  <th class="text-center">Màu</th>
                  <th class="text-center">SL</th>
                  <th class="text-right">Giá nhập</th>
                </tr>
                <tr *ngFor="let i of details.pageMatches" (click)="add(i)">
                  <td class="text-left"><good class="nowrap bold spacy" [sku]="i.SKU"></good></td>
                  <td class="text-center bold text-info">{{i.Color}}</td>
                  <td class="text-center">{{i.Quantity - i.Provided}}</td>
                  <td class="text-right">
                    <span *ngIf="i.ImportUnitPrice > 0"><b class="text-success">{{i.ImportUnitPrice | number : '1.0-2' : 'en-US'}}</b><span class="opacity-75 hlf-margin-left">¥/m</span></span>
                    <small class="text-danger" *ngIf="i.ImportUnitPrice <= 0">chưa có giá</small>
                  </td>
                </tr>
                <tr class="footer" *ngIf="details.pages.length > 1">
                  <td [colSpan]="4" class="text-center"><pagination [target]="details"></pagination></td>
                </tr>
              </table>

            </div>
            <scrollbar [target]="scrollableRight" [ngClass]="{'full-height': !selected.order}"></scrollbar>
          </div>
          <div class="flex col">      
            <button *ngIf="selected.order" class="bg-success text-white" (click)="toggle(selected.order)"><span>{{'Đóng đơn' | lang}} {{selected.order.Tag}}</span></button>
          </div>

        </div>
      </panel>

    </div>

  </div>

  <scrollbar [target]="scrollableX" class="bottom"></scrollbar>
</div>

<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop: true }"></ngx-loading>
